import { EventEmitter, Injectable } from "@angular/core";
import { AdminSnackbarComponent } from "../../admin/notifications/admin-snackbar/admin-snackbar.component";
import { BehaviorSubject, Observable } from "rxjs";
import { SnackbarStates } from "src/app/enums/snack-bar/snack-bar";

@Injectable({
  providedIn: "root",
})
export class SnackBarService {
  private isNetworkOnlineSubject = new BehaviorSubject<boolean>(true);
  isNetworkOnline$: Observable<boolean> =
    this.isNetworkOnlineSubject.asObservable();

  private isPremiseDownSubject = new BehaviorSubject<boolean>(false);
  isPremiseDown$: Observable<boolean> =
    this.isPremiseDownSubject.asObservable();

  private isCloudDownSubject = new BehaviorSubject<boolean>(false);
  isCloudDown$: Observable<boolean> = this.isCloudDownSubject.asObservable();

  snackBarEvent: EventEmitter<{ type: SnackbarStates; msg: string }> =
    new EventEmitter<{ type: SnackbarStates; msg: string }>();
  currentState = SnackbarStates.NOTIFICATION;

  constructor() {}

  SetNetworkStatus(isOnline: boolean) {
    this.isNetworkOnlineSubject.next(isOnline);
  }

  SetPremiseDown(isPremise: boolean) {
    this.isPremiseDownSubject.next(isPremise);
  }

  SetCloudDown(isCloud: boolean) {
    this.isCloudDownSubject.next(isCloud);
  }

  /**
   * @deprecated The method should not be used
   */
  showSnackBar(msg = "", isAdmin = true) {
    if (isAdmin) {
      this.showNotification(msg);
      return;
    }
    let x = document.getElementById("snackbarIntegrA");
    x.innerHTML = msg;
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  }

  showLoginSnackBar(msg = "", color) {
    let x = document.getElementById("snackbarLogin");
    x.innerHTML = msg;
    x.style.backgroundColor = color;
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 5000);
  }

  showLoginSnackBarV2(msg = "", type: string) {
    let x = document.getElementById("snackbarLogin");
    x.innerHTML = msg;
    let color;

    switch (type) {
      case "success":
        color = "#5cb85c";
        break;

      case "warning":
        color = "#f0ad4e";
        break;

      case "danger":
        color = "#d9534f";
        break;

      case "info":
        color = "#5bc0de";
        break;

      case "primary":
        color = "#0275d8";
        break;
    }
    x.style.backgroundColor = color;
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 5000);
  }

  startLoadingSnack(msg, viewChildRef?) {
    1;
    if (!viewChildRef) {
      1;
      this.snackBarEvent.emit({ type: SnackbarStates.LOADING, msg: msg });
      return;
    }
    viewChildRef.showLoader(msg);
  }

  showNotification(msg, viewChildRef?, isError = undefined, State = undefined) {
    let state;
    if (
      msg?.toLowerCase().includes("error") ||
      msg?.toLowerCase().includes("fail") ||
      msg?.toLowerCase().includes("cancel")
    )
      isError = true;

    if (State === undefined) {
      switch (isError) {
        case true:
          state = SnackbarStates.ERROR_MESSAGE;
          break;
        case false:
          state = SnackbarStates.SUCCESS_MESSAGE;
          break;
        default:
          state = SnackbarStates.NOTIFICATION;
          break;
      }
    } else state = SnackbarStates.INFO;

    if (!viewChildRef) {
      state;
      this.snackBarEvent.emit({ type: state, msg: msg });
      return;
    }
    viewChildRef.showNotification(msg);
  }

  mockError() {
    this.showNotification("User does not have this permission", null, true);
  }

  eventHandler(value: {
    type: SnackbarStates;
    msg: string;
    snackbarRef: AdminSnackbarComponent;
  }) {
    switch (value.type) {
      case SnackbarStates.LOADING:
        value.snackbarRef.showLoader(value.msg);
        break;
      case SnackbarStates.NOTIFICATION:
        value.snackbarRef.showNotification(value.msg);
        break;

      default:
        value.snackbarRef.showNotification(value.msg, value.type);
        break;
    }
  }
}
